<template>
  <div>
      <div class="listing-content listing-content-locatorMap">
          <div class="infoMessages" v-if="processing">Čekám na souřadnice...</div>
          <contact-contact-list v-if="false === processing"/>
      </div>
      <div class="map">
          <contact-map/>
      </div>
  </div>

</template>

<script>
    import {mapActions} from 'vuex';
    import {getLocation} from '../locator/helpers/geolocation';
    import {FETCH_CONTACTS} from './action';
    import {NAMESPACE} from './store';
    import ContactContactList from './ContactList';
    import ContactMap from './Map';


    export default {
        name: 'ContactNearestTab',
        components: {
            ContactMap,
            ContactContactList
        },
        data() {
            return {
                processing: false,
            }
        },
        mounted() {
            this.processing = true;
            getLocation()
                .then(coords => {
                    this.processing = false;
                    this[FETCH_CONTACTS](coords);
                }).catch(() => this[FETCH_CONTACTS]())
                .finally(() => this.processing = false);
        },
        methods: {
            ...mapActions(NAMESPACE, [FETCH_CONTACTS])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/NearestTab.vue